import React from 'react';
import {connect} from 'react-redux';
import Letter from '../lib/Letter';
import {ASSETS_CDN} from "../../constants";

const ringBand = `${ ASSETS_CDN }/ring-band.png`;
const ringCenter = `${ ASSETS_CDN }/ring-center.png`;

class PreviewContainer extends React.Component {
    render() {
        let className = '';
        className += `customizer-preview `;
        className += `customizer-preview--ring `;
        className += `${this.props.color.description.toLowerCase().replace(' ', '-')} `;

        let proportion = (18 - this.props.ringSize) / 16; // 1 ~ .125

        const style = {
            width: `${60 + Math.sqrt(60 / proportion)}px`,
            height: '13px',
        };

        let styleRight = Object.assign({}, style,{
            marginLeft: '-6px',
            height: '15px',
        });

        let styleLeft = Object.assign({}, style,{
            transform: 'scaleX(-1)',
            marginRight: '-8px',
            height: '15px',
        });

        return (
            <div className={className}>
                <div className="customizer-preview__container">
                    {this.props.input.length === 0 ? (
                        <div className='customizer-preview__band-center'>type something</div>
                    ) : (
                        <>
                            <img className='customizer-preview__band-back' style={style} src={ringCenter} alt="Ring center"/>

                            <div className='customizer-preview__band-center'>
                                <img className='customizer-preview__band' style={styleLeft} src={ringBand} alt="Ring band"/>

                                <div className="customizer-preview__letters">
                                    {this.props.input.slice(0, 3).map((letter, index) => <Letter key={index} letter={letter}/>)}
                                </div>

                                <img className='customizer-preview__band' style={styleRight} src={ringBand} alt="Ring band"/>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        input: state.input.split(''),
        ringSize: state.ringSize,
        color: state.goldColor,
    }
};

export default connect(mapStateToProps)(PreviewContainer);
